import React from "react";
import { INSIDE } from "../../mock/mock";
import { BookOpen, MapPin, Video, Users, Sparkles, Link2 } from "lucide-react";

const icons = [BookOpen, MapPin, Video, Users, Sparkles, Link2];

export default function WhatsInside() {
  return (
    <section id="program" className="bg-[#fdfaf5]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-16 md:py-24">
        <div className="text-center max-w-3xl mx-auto">
          <p className="eyebrow text-lg">{INSIDE.eyebrow}</p>
          <div className="mx-auto mt-3 ornament-line" />
          <h2 className="mt-4 font-serif-display text-3xl md:text-5xl leading-tight text-[#1a1a1a]">
            {INSIDE.heading}
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {INSIDE.items.map((it, i) => {
            const Icon = icons[i % icons.length];
            return (
              <div key={it.title} className="group rounded-2xl border border-[#ead9bd] bg-white p-6 md:p-7 lift">
                <div className="h-11 w-11 rounded-xl bg-[#f3ead9] text-[#c9a961] grid place-items-center">
                  <Icon size={20} />
                </div>
                <h3 className="mt-5 font-serif-display text-2xl text-[#1a1a1a]">{it.title}</h3>
                <p className="mt-2 text-[14.5px] leading-relaxed text-[#1a1a1a]/70">{it.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
